import { voltrUploadStore } from '@/stores/voltrUpload.store';

/**
 * Where this deal's picks stand, for the deal page's header: being sent
 * ("Uploading content"), or picked and waiting for Submit. A failed pick
 * leaves the header alone: the uploader's own Try again speaks for it.
 */
export type HeaderUploadPhase = 'uploading' | 'ready' | null;

export function uploadPhaseFor(actionId: number, store = voltrUploadStore): HeaderUploadPhase {
  if (store.running && store.runningFor === actionId) return 'uploading';
  if (!store.isFor(actionId) || store.items.some((i) => i.phase === 'error')) return null;
  return store.items.some((i) => i.phase === 'idle') ? 'ready' : null;
}
